import { render, staticRenderFns } from "./SetupBrandCategoryTabs.vue?vue&type=template&id=538ed2ec&scoped=true"
import script from "./SetupBrandCategoryTabs.vue?vue&type=script&lang=js"
export * from "./SetupBrandCategoryTabs.vue?vue&type=script&lang=js"
import style0 from "./SetupBrandCategoryTabs.vue?vue&type=style&index=0&id=538ed2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ed2ec",
  null
  
)

export default component.exports